import OwnersStory from './OwnersStory';

export default OwnersStory;
